import { ReactNode } from 'react'

const Modal = ({
    id,
    title,
    children,
    closeBottom,
}: {
    id: string
    title: string
    children: ReactNode
    closeBottom?: boolean
}) => {
    return (
        <dialog id={id} className="modal">
            <div className="modal-box">
                {!closeBottom && (
                    <form method="dialog">
                        {/* if there is a button in form, it will close the modal */}
                        <button className="btn btn-circle btn-ghost btn-sm absolute right-2 top-2">✕</button>
                    </form>
                )}
                <h3 className="text-lg font-bold">{title}</h3>
                <div className="m-4 flex flex-col gap-2">{children}</div>
                {closeBottom && (
                    <div className="modal-action">
                        <form method="dialog">
                            {/* if there is a button in form, it will close the modal */}
                            <button className="btn">Close</button>
                        </form>
                    </div>
                )}
            </div>
            <form method="dialog" className="modal-backdrop">
                <button>close</button>
            </form>
        </dialog>
    )
}
export default Modal

export function showModal(id: string) {
    const el = document.querySelector(`#${id}`)
    if (isDialog(el)) el.showModal()
}
function isDialog(el: Element | null): el is HTMLDialogElement {
    return el?.tagName.toUpperCase() === 'DIALOG'
}
